// source: wasm/query.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var gogoproto_gogo_pb = require('../gogoproto/gogo_pb.js');
goog.object.extend(proto, gogoproto_gogo_pb);
var wasm_types_pb = require('../wasm/types_pb.js');
goog.object.extend(proto, wasm_types_pb);
var google_api_annotations_pb = require('../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var cosmos_base_query_v1beta1_pagination_pb = require('../cosmos/base/query/v1beta1/pagination_pb.js');
goog.object.extend(proto, cosmos_base_query_v1beta1_pagination_pb);
goog.exportSymbol('proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse', null, global);
goog.exportSymbol('proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress', null, global);
goog.exportSymbol('proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest', null, global);
goog.exportSymbol('proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse', null, global);
goog.exportSymbol('proto.wasmd.x.wasmd.v1beta1.QueryCodeRequest', null, global);
goog.exportSymbol('proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse', null, global);
goog.exportSymbol('proto.wasmd.x.wasmd.v1beta1.QueryCodesRequest', null, global);
goog.exportSymbol('proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse', null, global);
goog.exportSymbol('proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest', null, global);
goog.exportSymbol('proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse', null, global);
goog.exportSymbol('proto.wasmd.x.wasmd.v1beta1.QueryContractInfoRequest', null, global);
goog.exportSymbol('proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse', null, global);
goog.exportSymbol('proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest', null, global);
goog.exportSymbol('proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse', null, global);
goog.exportSymbol('proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest', null, global);
goog.exportSymbol('proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateResponse', null, global);
goog.exportSymbol('proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest', null, global);
goog.exportSymbol('proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wasmd.x.wasmd.v1beta1.QueryContractInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wasmd.x.wasmd.v1beta1.QueryContractInfoRequest.displayName = 'proto.wasmd.x.wasmd.v1beta1.QueryContractInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse.displayName = 'proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest.displayName = 'proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse.repeatedFields_, null);
};
goog.inherits(proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse.displayName = 'proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest.displayName = 'proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress.displayName = 'proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse.repeatedFields_, null);
};
goog.inherits(proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse.displayName = 'proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest.displayName = 'proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse.repeatedFields_, null);
};
goog.inherits(proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse.displayName = 'proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest.displayName = 'proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateResponse.displayName = 'proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest.displayName = 'proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateResponse.displayName = 'proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wasmd.x.wasmd.v1beta1.QueryCodeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wasmd.x.wasmd.v1beta1.QueryCodeRequest.displayName = 'proto.wasmd.x.wasmd.v1beta1.QueryCodeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.displayName = 'proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse.displayName = 'proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wasmd.x.wasmd.v1beta1.QueryCodesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wasmd.x.wasmd.v1beta1.QueryCodesRequest.displayName = 'proto.wasmd.x.wasmd.v1beta1.QueryCodesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse.repeatedFields_, null);
};
goog.inherits(proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse.displayName = 'proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wasmd.x.wasmd.v1beta1.QueryContractInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryContractInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    address: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractInfoRequest}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wasmd.x.wasmd.v1beta1.QueryContractInfoRequest;
  return proto.wasmd.x.wasmd.v1beta1.QueryContractInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryContractInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractInfoRequest}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wasmd.x.wasmd.v1beta1.QueryContractInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryContractInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string address = 1;
 * @return {string}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractInfoRequest.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractInfoRequest} returns this
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractInfoRequest.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    address: jspb.Message.getFieldWithDefault(msg, 1, ""),
    contractInfo: (f = msg.getContractInfo()) && wasm_types_pb.ContractInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse;
  return proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 2:
      var value = new wasm_types_pb.ContractInfo;
      reader.readMessage(value,wasm_types_pb.ContractInfo.deserializeBinaryFromReader);
      msg.setContractInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContractInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      wasm_types_pb.ContractInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional string address = 1;
 * @return {string}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse} returns this
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ContractInfo contract_info = 2;
 * @return {?proto.wasmd.x.wasmd.v1beta1.ContractInfo}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse.prototype.getContractInfo = function() {
  return /** @type{?proto.wasmd.x.wasmd.v1beta1.ContractInfo} */ (
    jspb.Message.getWrapperField(this, wasm_types_pb.ContractInfo, 2));
};


/**
 * @param {?proto.wasmd.x.wasmd.v1beta1.ContractInfo|undefined} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse} returns this
*/
proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse.prototype.setContractInfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse} returns this
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse.prototype.clearContractInfo = function() {
  return this.setContractInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractInfoResponse.prototype.hasContractInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    address: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pagination: (f = msg.getPagination()) && cosmos_base_query_v1beta1_pagination_pb.PageRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest;
  return proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 2:
      var value = new cosmos_base_query_v1beta1_pagination_pb.PageRequest;
      reader.readMessage(value,cosmos_base_query_v1beta1_pagination_pb.PageRequest.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      cosmos_base_query_v1beta1_pagination_pb.PageRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional string address = 1;
 * @return {string}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest} returns this
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional cosmos.base.query.v1beta1.PageRequest pagination = 2;
 * @return {?proto.cosmos.base.query.v1beta1.PageRequest}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest.prototype.getPagination = function() {
  return /** @type{?proto.cosmos.base.query.v1beta1.PageRequest} */ (
    jspb.Message.getWrapperField(this, cosmos_base_query_v1beta1_pagination_pb.PageRequest, 2));
};


/**
 * @param {?proto.cosmos.base.query.v1beta1.PageRequest|undefined} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest} returns this
*/
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest} returns this
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    entriesList: jspb.Message.toObjectList(msg.getEntriesList(),
    wasm_types_pb.ContractCodeHistoryEntry.toObject, includeInstance),
    pagination: (f = msg.getPagination()) && cosmos_base_query_v1beta1_pagination_pb.PageResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse;
  return proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new wasm_types_pb.ContractCodeHistoryEntry;
      reader.readMessage(value,wasm_types_pb.ContractCodeHistoryEntry.deserializeBinaryFromReader);
      msg.addEntries(value);
      break;
    case 2:
      var value = new cosmos_base_query_v1beta1_pagination_pb.PageResponse;
      reader.readMessage(value,cosmos_base_query_v1beta1_pagination_pb.PageResponse.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      wasm_types_pb.ContractCodeHistoryEntry.serializeBinaryToWriter
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      cosmos_base_query_v1beta1_pagination_pb.PageResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ContractCodeHistoryEntry entries = 1;
 * @return {!Array<!proto.wasmd.x.wasmd.v1beta1.ContractCodeHistoryEntry>}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse.prototype.getEntriesList = function() {
  return /** @type{!Array<!proto.wasmd.x.wasmd.v1beta1.ContractCodeHistoryEntry>} */ (
    jspb.Message.getRepeatedWrapperField(this, wasm_types_pb.ContractCodeHistoryEntry, 1));
};


/**
 * @param {!Array<!proto.wasmd.x.wasmd.v1beta1.ContractCodeHistoryEntry>} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse} returns this
*/
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse.prototype.setEntriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.wasmd.x.wasmd.v1beta1.ContractCodeHistoryEntry=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wasmd.x.wasmd.v1beta1.ContractCodeHistoryEntry}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse.prototype.addEntries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.wasmd.x.wasmd.v1beta1.ContractCodeHistoryEntry, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse} returns this
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse.prototype.clearEntriesList = function() {
  return this.setEntriesList([]);
};


/**
 * optional cosmos.base.query.v1beta1.PageResponse pagination = 2;
 * @return {?proto.cosmos.base.query.v1beta1.PageResponse}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse.prototype.getPagination = function() {
  return /** @type{?proto.cosmos.base.query.v1beta1.PageResponse} */ (
    jspb.Message.getWrapperField(this, cosmos_base_query_v1beta1_pagination_pb.PageResponse, 2));
};


/**
 * @param {?proto.cosmos.base.query.v1beta1.PageResponse|undefined} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse} returns this
*/
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse} returns this
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractHistoryResponse.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    codeId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pagination: (f = msg.getPagination()) && cosmos_base_query_v1beta1_pagination_pb.PageRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest;
  return proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setCodeId(value);
      break;
    case 2:
      var value = new cosmos_base_query_v1beta1_pagination_pb.PageRequest;
      reader.readMessage(value,cosmos_base_query_v1beta1_pagination_pb.PageRequest.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCodeId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      cosmos_base_query_v1beta1_pagination_pb.PageRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 code_id = 1;
 * @return {number}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest.prototype.getCodeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest} returns this
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest.prototype.setCodeId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional cosmos.base.query.v1beta1.PageRequest pagination = 2;
 * @return {?proto.cosmos.base.query.v1beta1.PageRequest}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest.prototype.getPagination = function() {
  return /** @type{?proto.cosmos.base.query.v1beta1.PageRequest} */ (
    jspb.Message.getWrapperField(this, cosmos_base_query_v1beta1_pagination_pb.PageRequest, 2));
};


/**
 * @param {?proto.cosmos.base.query.v1beta1.PageRequest|undefined} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest} returns this
*/
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest} returns this
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress.prototype.toObject = function(opt_includeInstance) {
  return proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress.toObject = function(includeInstance, msg) {
  var f, obj = {
    address: jspb.Message.getFieldWithDefault(msg, 1, ""),
    contractInfo: (f = msg.getContractInfo()) && wasm_types_pb.ContractInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress}
 */
proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress;
  return proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress}
 */
proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 2:
      var value = new wasm_types_pb.ContractInfo;
      reader.readMessage(value,wasm_types_pb.ContractInfo.deserializeBinaryFromReader);
      msg.setContractInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContractInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      wasm_types_pb.ContractInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional string address = 1;
 * @return {string}
 */
proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress} returns this
 */
proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ContractInfo contract_info = 2;
 * @return {?proto.wasmd.x.wasmd.v1beta1.ContractInfo}
 */
proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress.prototype.getContractInfo = function() {
  return /** @type{?proto.wasmd.x.wasmd.v1beta1.ContractInfo} */ (
    jspb.Message.getWrapperField(this, wasm_types_pb.ContractInfo, 2));
};


/**
 * @param {?proto.wasmd.x.wasmd.v1beta1.ContractInfo|undefined} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress} returns this
*/
proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress.prototype.setContractInfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress} returns this
 */
proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress.prototype.clearContractInfo = function() {
  return this.setContractInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress.prototype.hasContractInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    contractInfosList: jspb.Message.toObjectList(msg.getContractInfosList(),
    proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress.toObject, includeInstance),
    pagination: (f = msg.getPagination()) && cosmos_base_query_v1beta1_pagination_pb.PageResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse;
  return proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress;
      reader.readMessage(value,proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress.deserializeBinaryFromReader);
      msg.addContractInfos(value);
      break;
    case 2:
      var value = new cosmos_base_query_v1beta1_pagination_pb.PageResponse;
      reader.readMessage(value,cosmos_base_query_v1beta1_pagination_pb.PageResponse.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContractInfosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress.serializeBinaryToWriter
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      cosmos_base_query_v1beta1_pagination_pb.PageResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ContractInfoWithAddress contract_infos = 1;
 * @return {!Array<!proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress>}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse.prototype.getContractInfosList = function() {
  return /** @type{!Array<!proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress, 1));
};


/**
 * @param {!Array<!proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress>} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse} returns this
*/
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse.prototype.setContractInfosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse.prototype.addContractInfos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.wasmd.x.wasmd.v1beta1.ContractInfoWithAddress, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse} returns this
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse.prototype.clearContractInfosList = function() {
  return this.setContractInfosList([]);
};


/**
 * optional cosmos.base.query.v1beta1.PageResponse pagination = 2;
 * @return {?proto.cosmos.base.query.v1beta1.PageResponse}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse.prototype.getPagination = function() {
  return /** @type{?proto.cosmos.base.query.v1beta1.PageResponse} */ (
    jspb.Message.getWrapperField(this, cosmos_base_query_v1beta1_pagination_pb.PageResponse, 2));
};


/**
 * @param {?proto.cosmos.base.query.v1beta1.PageResponse|undefined} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse} returns this
*/
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse} returns this
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wasmd.x.wasmd.v1beta1.QueryContractsByCodeResponse.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    address: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pagination: (f = msg.getPagination()) && cosmos_base_query_v1beta1_pagination_pb.PageRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest}
 */
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest;
  return proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest}
 */
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 2:
      var value = new cosmos_base_query_v1beta1_pagination_pb.PageRequest;
      reader.readMessage(value,cosmos_base_query_v1beta1_pagination_pb.PageRequest.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      cosmos_base_query_v1beta1_pagination_pb.PageRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional string address = 1;
 * @return {string}
 */
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest} returns this
 */
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional cosmos.base.query.v1beta1.PageRequest pagination = 2;
 * @return {?proto.cosmos.base.query.v1beta1.PageRequest}
 */
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest.prototype.getPagination = function() {
  return /** @type{?proto.cosmos.base.query.v1beta1.PageRequest} */ (
    jspb.Message.getWrapperField(this, cosmos_base_query_v1beta1_pagination_pb.PageRequest, 2));
};


/**
 * @param {?proto.cosmos.base.query.v1beta1.PageRequest|undefined} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest} returns this
*/
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest} returns this
 */
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    modelsList: jspb.Message.toObjectList(msg.getModelsList(),
    wasm_types_pb.Model.toObject, includeInstance),
    pagination: (f = msg.getPagination()) && cosmos_base_query_v1beta1_pagination_pb.PageResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse}
 */
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse;
  return proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse}
 */
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new wasm_types_pb.Model;
      reader.readMessage(value,wasm_types_pb.Model.deserializeBinaryFromReader);
      msg.addModels(value);
      break;
    case 2:
      var value = new cosmos_base_query_v1beta1_pagination_pb.PageResponse;
      reader.readMessage(value,cosmos_base_query_v1beta1_pagination_pb.PageResponse.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getModelsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      wasm_types_pb.Model.serializeBinaryToWriter
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      cosmos_base_query_v1beta1_pagination_pb.PageResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Model models = 1;
 * @return {!Array<!proto.wasmd.x.wasmd.v1beta1.Model>}
 */
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse.prototype.getModelsList = function() {
  return /** @type{!Array<!proto.wasmd.x.wasmd.v1beta1.Model>} */ (
    jspb.Message.getRepeatedWrapperField(this, wasm_types_pb.Model, 1));
};


/**
 * @param {!Array<!proto.wasmd.x.wasmd.v1beta1.Model>} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse} returns this
*/
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse.prototype.setModelsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.wasmd.x.wasmd.v1beta1.Model=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wasmd.x.wasmd.v1beta1.Model}
 */
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse.prototype.addModels = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.wasmd.x.wasmd.v1beta1.Model, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse} returns this
 */
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse.prototype.clearModelsList = function() {
  return this.setModelsList([]);
};


/**
 * optional cosmos.base.query.v1beta1.PageResponse pagination = 2;
 * @return {?proto.cosmos.base.query.v1beta1.PageResponse}
 */
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse.prototype.getPagination = function() {
  return /** @type{?proto.cosmos.base.query.v1beta1.PageResponse} */ (
    jspb.Message.getWrapperField(this, cosmos_base_query_v1beta1_pagination_pb.PageResponse, 2));
};


/**
 * @param {?proto.cosmos.base.query.v1beta1.PageResponse|undefined} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse} returns this
*/
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse} returns this
 */
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wasmd.x.wasmd.v1beta1.QueryAllContractStateResponse.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    address: jspb.Message.getFieldWithDefault(msg, 1, ""),
    queryData: msg.getQueryData_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest}
 */
proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest;
  return proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest}
 */
proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setQueryData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQueryData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional string address = 1;
 * @return {string}
 */
proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest} returns this
 */
proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bytes query_data = 2;
 * @return {!(string|Uint8Array)}
 */
proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest.prototype.getQueryData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes query_data = 2;
 * This is a type-conversion wrapper around `getQueryData()`
 * @return {string}
 */
proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest.prototype.getQueryData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getQueryData()));
};


/**
 * optional bytes query_data = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getQueryData()`
 * @return {!Uint8Array}
 */
proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest.prototype.getQueryData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getQueryData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest} returns this
 */
proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateRequest.prototype.setQueryData = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    data: msg.getData_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateResponse}
 */
proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateResponse;
  return proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateResponse}
 */
proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes data = 1;
 * @return {!(string|Uint8Array)}
 */
proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateResponse.prototype.getData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes data = 1;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateResponse.prototype.getData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getData()));
};


/**
 * optional bytes data = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateResponse.prototype.getData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateResponse} returns this
 */
proto.wasmd.x.wasmd.v1beta1.QueryRawContractStateResponse.prototype.setData = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    address: jspb.Message.getFieldWithDefault(msg, 1, ""),
    queryData: msg.getQueryData_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest}
 */
proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest;
  return proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest}
 */
proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setQueryData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQueryData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional string address = 1;
 * @return {string}
 */
proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest} returns this
 */
proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bytes query_data = 2;
 * @return {!(string|Uint8Array)}
 */
proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest.prototype.getQueryData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes query_data = 2;
 * This is a type-conversion wrapper around `getQueryData()`
 * @return {string}
 */
proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest.prototype.getQueryData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getQueryData()));
};


/**
 * optional bytes query_data = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getQueryData()`
 * @return {!Uint8Array}
 */
proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest.prototype.getQueryData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getQueryData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest} returns this
 */
proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateRequest.prototype.setQueryData = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    data: msg.getData_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateResponse}
 */
proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateResponse;
  return proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateResponse}
 */
proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes data = 1;
 * @return {!(string|Uint8Array)}
 */
proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateResponse.prototype.getData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes data = 1;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateResponse.prototype.getData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getData()));
};


/**
 * optional bytes data = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateResponse.prototype.getData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateResponse} returns this
 */
proto.wasmd.x.wasmd.v1beta1.QuerySmartContractStateResponse.prototype.setData = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wasmd.x.wasmd.v1beta1.QueryCodeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryCodeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    codeId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryCodeRequest}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wasmd.x.wasmd.v1beta1.QueryCodeRequest;
  return proto.wasmd.x.wasmd.v1beta1.QueryCodeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryCodeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryCodeRequest}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setCodeId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wasmd.x.wasmd.v1beta1.QueryCodeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryCodeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCodeId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
};


/**
 * optional uint64 code_id = 1;
 * @return {number}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodeRequest.prototype.getCodeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryCodeRequest} returns this
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodeRequest.prototype.setCodeId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    codeId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    creator: jspb.Message.getFieldWithDefault(msg, 2, ""),
    dataHash: msg.getDataHash_asB64(),
    source: jspb.Message.getFieldWithDefault(msg, 4, ""),
    builder: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse}
 */
proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse;
  return proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse}
 */
proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setCodeId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreator(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setDataHash(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuilder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCodeId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getCreator();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDataHash_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBuilder();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional uint64 code_id = 1;
 * @return {number}
 */
proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.prototype.getCodeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse} returns this
 */
proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.prototype.setCodeId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string creator = 2;
 * @return {string}
 */
proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.prototype.getCreator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse} returns this
 */
proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.prototype.setCreator = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bytes data_hash = 3;
 * @return {!(string|Uint8Array)}
 */
proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.prototype.getDataHash = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes data_hash = 3;
 * This is a type-conversion wrapper around `getDataHash()`
 * @return {string}
 */
proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.prototype.getDataHash_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getDataHash()));
};


/**
 * optional bytes data_hash = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getDataHash()`
 * @return {!Uint8Array}
 */
proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.prototype.getDataHash_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getDataHash()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse} returns this
 */
proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.prototype.setDataHash = function(value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};


/**
 * optional string source = 4;
 * @return {string}
 */
proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse} returns this
 */
proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string builder = 5;
 * @return {string}
 */
proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.prototype.getBuilder = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse} returns this
 */
proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.prototype.setBuilder = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    codeInfo: (f = msg.getCodeInfo()) && proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.toObject(includeInstance, f),
    data: msg.getData_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse;
  return proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse;
      reader.readMessage(value,proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.deserializeBinaryFromReader);
      msg.setCodeInfo(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCodeInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.serializeBinaryToWriter
    );
  }
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional CodeInfoResponse code_info = 1;
 * @return {?proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse.prototype.getCodeInfo = function() {
  return /** @type{?proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse} */ (
    jspb.Message.getWrapperField(this, proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse, 1));
};


/**
 * @param {?proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse|undefined} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse} returns this
*/
proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse.prototype.setCodeInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse} returns this
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse.prototype.clearCodeInfo = function() {
  return this.setCodeInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse.prototype.hasCodeInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bytes data = 2;
 * @return {!(string|Uint8Array)}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse.prototype.getData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes data = 2;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse.prototype.getData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getData()));
};


/**
 * optional bytes data = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse.prototype.getData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse} returns this
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodeResponse.prototype.setData = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wasmd.x.wasmd.v1beta1.QueryCodesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryCodesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    pagination: (f = msg.getPagination()) && cosmos_base_query_v1beta1_pagination_pb.PageRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryCodesRequest}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wasmd.x.wasmd.v1beta1.QueryCodesRequest;
  return proto.wasmd.x.wasmd.v1beta1.QueryCodesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryCodesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryCodesRequest}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new cosmos_base_query_v1beta1_pagination_pb.PageRequest;
      reader.readMessage(value,cosmos_base_query_v1beta1_pagination_pb.PageRequest.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wasmd.x.wasmd.v1beta1.QueryCodesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryCodesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      cosmos_base_query_v1beta1_pagination_pb.PageRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional cosmos.base.query.v1beta1.PageRequest pagination = 1;
 * @return {?proto.cosmos.base.query.v1beta1.PageRequest}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodesRequest.prototype.getPagination = function() {
  return /** @type{?proto.cosmos.base.query.v1beta1.PageRequest} */ (
    jspb.Message.getWrapperField(this, cosmos_base_query_v1beta1_pagination_pb.PageRequest, 1));
};


/**
 * @param {?proto.cosmos.base.query.v1beta1.PageRequest|undefined} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryCodesRequest} returns this
*/
proto.wasmd.x.wasmd.v1beta1.QueryCodesRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryCodesRequest} returns this
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodesRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodesRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    codeInfosList: jspb.Message.toObjectList(msg.getCodeInfosList(),
    proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.toObject, includeInstance),
    pagination: (f = msg.getPagination()) && cosmos_base_query_v1beta1_pagination_pb.PageResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse;
  return proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse;
      reader.readMessage(value,proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.deserializeBinaryFromReader);
      msg.addCodeInfos(value);
      break;
    case 2:
      var value = new cosmos_base_query_v1beta1_pagination_pb.PageResponse;
      reader.readMessage(value,cosmos_base_query_v1beta1_pagination_pb.PageResponse.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCodeInfosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse.serializeBinaryToWriter
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      cosmos_base_query_v1beta1_pagination_pb.PageResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CodeInfoResponse code_infos = 1;
 * @return {!Array<!proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse>}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse.prototype.getCodeInfosList = function() {
  return /** @type{!Array<!proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse, 1));
};


/**
 * @param {!Array<!proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse>} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse} returns this
*/
proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse.prototype.setCodeInfosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse.prototype.addCodeInfos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.wasmd.x.wasmd.v1beta1.CodeInfoResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse} returns this
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse.prototype.clearCodeInfosList = function() {
  return this.setCodeInfosList([]);
};


/**
 * optional cosmos.base.query.v1beta1.PageResponse pagination = 2;
 * @return {?proto.cosmos.base.query.v1beta1.PageResponse}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse.prototype.getPagination = function() {
  return /** @type{?proto.cosmos.base.query.v1beta1.PageResponse} */ (
    jspb.Message.getWrapperField(this, cosmos_base_query_v1beta1_pagination_pb.PageResponse, 2));
};


/**
 * @param {?proto.cosmos.base.query.v1beta1.PageResponse|undefined} value
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse} returns this
*/
proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse} returns this
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wasmd.x.wasmd.v1beta1.QueryCodesResponse.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.wasmd.x.wasmd.v1beta1);
